export { CnPage } from '@cainiaofe/cn-ui';
